import './Portada.css';
import { useSiteSettings } from '../../Contextos/SiteContext';
export default function SiteAnnouncement() {
  const { settings } = useSiteSettings();
  return settings.announcement ? <p className="site-announcement">{settings.announcement}</p> : null;
}
